// Fleet Health Dashboard API client (admin). One GET probes every saved
// connection server-side (bounded-parallel) and returns per-connection health.
import { api } from './api.js';

// → { connections: [{ connId, name, groupName, color, reachable, error?,
//      server?, uptimeSec, threadsConnected, summary?, lastBackup? }], probedAt }
export const probeFleetHealth = () => api.get('/api/tools/fleet-health');
